(function () {
  'use strict';

  if (window.KKCartDrawerLoader) {
    return;
  }

  var script = document.currentScript || document.querySelector('[data-kk-cart-loader]');
  if (!script) {
    return;
  }

  var styleSource = script.getAttribute('data-style-src') || '';
  var controllerSource = script.getAttribute('data-controller-src') || '';
  var cartUrl = script.getAttribute('data-cart-url') || '/cart';
  var loadPromise = null;
  var loaded = false;
  var INTENT_SELECTOR = [
    '[data-kk-cart-open]',
    '[data-header-cart-button]',
    '.site-header-cart-button',
    '[data-quick-buy][data-variant-id]'
  ].join(',');

  function cartPathname() {
    try {
      return new URL(cartUrl, document.baseURI).pathname.replace(/\/$/, '');
    } catch (error) {
      return '/cart';
    }
  }

  function isCartLink(link) {
    if (!link || !link.href) {
      return false;
    }

    try {
      return new URL(link.href, document.baseURI).pathname.replace(/\/$/, '') === cartPathname();
    } catch (error) {
      return false;
    }
  }

  function isAddForm(form) {
    if (
      !form ||
      form.matches('[data-kk-cart-bypass], [data-kk-mystery-set-form]') ||
      form.querySelector('[data-kk-mystery-set-atc]')
    ) {
      return false;
    }

    try {
      return /\/cart\/add(?:\.js)?\/?$/.test(new URL(form.action, document.baseURI).pathname);
    } catch (error) {
      return false;
    }
  }

  function loadStylesheet() {
    var existing = document.querySelector('link[data-kk-cart-drawer-styles]');
    if (existing && existing.sheet) {
      return Promise.resolve(existing);
    }

    return new Promise(function (resolve, reject) {
      var link = existing || document.createElement('link');
      var settled = false;

      function finish(callback, value) {
        if (settled) {
          return;
        }
        settled = true;
        link.removeEventListener('load', handleLoad);
        link.removeEventListener('error', handleError);
        callback(value);
      }

      function handleLoad() {
        link.setAttribute('data-loaded', 'true');
        finish(resolve, link);
      }

      function handleError() {
        finish(reject, new Error('Ostoskorin tyylejä ei voitu ladata.'));
      }

      link.addEventListener('load', handleLoad);
      link.addEventListener('error', handleError);

      if (!existing) {
        link.rel = 'stylesheet';
        link.href = styleSource;
        link.setAttribute('data-kk-cart-drawer-styles', '');
        document.head.appendChild(link);
      } else if (existing.getAttribute('data-loaded') === 'true') {
        finish(resolve, existing);
      }
    });
  }

  function loadController() {
    var existing = document.querySelector('script[data-kk-cart-drawer-controller]');
    if (existing && existing.getAttribute('data-loaded') === 'true') {
      return Promise.resolve(existing);
    }

    return new Promise(function (resolve, reject) {
      var controller = existing || document.createElement('script');
      var settled = false;

      function finish(callback, value) {
        if (settled) {
          return;
        }
        settled = true;
        controller.removeEventListener('load', handleLoad);
        controller.removeEventListener('error', handleError);
        callback(value);
      }

      function handleLoad() {
        controller.setAttribute('data-loaded', 'true');
        finish(resolve, controller);
      }

      function handleError() {
        finish(reject, new Error('Ostoskorin ohjainta ei voitu ladata.'));
      }

      controller.addEventListener('load', handleLoad);
      controller.addEventListener('error', handleError);

      if (!existing) {
        controller.src = controllerSource;
        controller.defer = true;
        controller.setAttribute('data-kk-cart-drawer-controller', '');
        document.head.appendChild(controller);
      } else if (existing.getAttribute('data-loaded') === 'true') {
        finish(resolve, existing);
      }
    });
  }

  function removeIntentListeners() {
    window.removeEventListener('pointerover', handleIntent, true);
    window.removeEventListener('focusin', handleIntent, true);
    window.removeEventListener('touchstart', handleIntent, true);
    window.removeEventListener('click', handleIntent, true);
    window.removeEventListener('submit', handleSubmit, true);
  }

  function load(options) {
    if (loadPromise) {
      return loadPromise;
    }

    document.documentElement.classList.add('kk-cart-assets-loading');

    // Wait for CSS before executing the controller. The head-level bridge can
    // replay the first click as soon as the controller binds, so this ordering
    // prevents an unstyled drawer flash on the first open.
    loadPromise = loadStylesheet()
      .then(loadController)
      .then(function () {
        loaded = true;
        document.documentElement.classList.remove('kk-cart-assets-loading');
        document.documentElement.classList.add('kk-cart-assets-ready');
        removeIntentListeners();
        document.dispatchEvent(new CustomEvent('kk:cart:assets-ready', {
          detail: options || {}
        }));
        return true;
      })
      .catch(function (error) {
        loadPromise = null;
        document.documentElement.classList.remove('kk-cart-assets-loading');
        document.dispatchEvent(new CustomEvent('kk:cart:assets-error', {
          detail: { error: error, message: error && error.message }
        }));
        throw error;
      });

    return loadPromise;
  }

  function findIntentTarget(event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) {
      return null;
    }

    return target.closest(INTENT_SELECTOR) || target.closest('a[href]');
  }

  function handleIntent(event) {
    if (loaded) {
      return;
    }

    var target = findIntentTarget(event);
    if (!target || (!target.matches(INTENT_SELECTOR) && !isCartLink(target))) {
      return;
    }

    load({ source: event.type }).catch(function () {});
  }

  function handleSubmit(event) {
    if (!loaded && isAddForm(event.target)) {
      load({ source: 'add-to-cart' }).catch(function () {});
    }
  }

  window.KKCartDrawerLoader = {
    load: load,
    isLoaded: function () { return loaded; }
  };

  // Capture at window level so loading starts before the head bridge queues and
  // stops the first cart click or add-to-cart submission at document level.
  window.addEventListener('pointerover', handleIntent, true);
  window.addEventListener('focusin', handleIntent, true);
  window.addEventListener('touchstart', handleIntent, { capture: true, passive: true });
  window.addEventListener('click', handleIntent, true);
  window.addEventListener('submit', handleSubmit, true);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (section && section.querySelector && section.querySelector('[data-kk-cart-drawer]')) {
      load({ source: 'theme-editor' }).catch(function () {});
    }
  });

  if (
    script.getAttribute('data-eager') === 'true' ||
    (window.Shopify && window.Shopify.designMode) ||
    (window.KKCartEarlyBridge && window.KKCartEarlyBridge.pendingCount() > 0)
  ) {
    load({ source: script.getAttribute('data-eager') === 'true' ? 'cart-page' : 'initial-pending' }).catch(function () {});
  }
}());
